<template>
  <div>
    <v-chip small color="primary" @click="$emit('click')">
      <v-icon left small>add</v-icon>
      Add
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'AddMissingValueChip',
};
</script>
